import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Observable, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: Socket;
  private messageSubject = new BehaviorSubject<any>(null);
  private connectionState = new BehaviorSubject<boolean>(false);

  constructor() {
    this.socket = io('http://103.68.109.25:8085', {
      transports: ['websocket'],
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5,
      withCredentials: true
    });

    this.setupSocketListeners();
  }

  private setupSocketListeners(): void {
    this.socket.on('connect', () => {
      console.log('Socket.IO Connected, socket id:', this.socket.id);
      this.connectionState.next(true);
    });

    this.socket.on('disconnect', () => {
      console.log('Socket.IO Disconnected');
      this.connectionState.next(false);
    });

    this.socket.on('car-response', (response: any) => {
      console.log('Raw car-response from server:', response);

      // Kiểm tra và chuyển đổi format message
      const message = {
        data: response.data,
        timestamp: response.timestamp
      };

      console.log('Processed car-response:', message);
      this.messageSubject.next(message);
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket.IO connection error:', error);
    });
  }

  sendMessage(message: any): void {
    console.log('Sending message:', message);
    if (message.event === 'request-car') {
      let requestData;
      switch(message.data.action) {
        case 'requestCar':
          requestData = {
            action: 'requestCar',
            data: {
              ticketId: message.data.ticketId,
              timestamp: new Date().toISOString()
            }
          };
          break;

        case 'updateCar':
          requestData = {
            action: 'updateCar',
            data: {
              timestamp: new Date().toISOString()
            }
          };
          break;
      }

      if (requestData) {
        console.log('Formatted request data:', requestData);
        this.socket.emit('request-car', requestData);
      }
    }
  }

  getMessages(): Observable<any> {
    return this.messageSubject.asObservable();
  }

  getConnectionState(): Observable<boolean> {
    return this.connectionState.asObservable();
  }

  disconnect(): void {
    if (this.socket) {
      console.log('Disconnecting socket...');
      this.socket.disconnect();
    }
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
